/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/NewPerson/Content/Email/Fields/EmailAddress/Empty",
  isInvalid,
  onChange
  
}) {
let newRelationEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'email.address',
})
let newRelationEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'email.address',
validate: fromValidate.email,
})
let newRelationEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_relation.email.address"
 validate="/Data/validate.js email"
 invalid={!newRelationEmailAddressIsValidData}
 value={newRelationEmailAddressValueData}
 onChange={newRelationEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}